import * as React from 'react'
const SvgComponent = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path fill="url(#ig_a)" d="M.5.5h15v15H.5z" />
    <defs>
      <pattern id="ig_a" width={1} height={1} patternContentUnits="objectBoundingBox">
        <use xlinkHref="#ig_b" transform="matrix(.00024 0 0 .00024 0 0)" />
      </pattern>
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
          <path
            fill="#F00073"
            d="M7 3h10c2.2 0 4 1.8 4 4v10c0 2.2-1.8 4-4 4H7c-2.2 0-4-1.8-4-4V7c0-2.2 1.8-4 4-4Z"
          />
          <path
            fill="#FFB200"
            d="M17 21a4 4 0 0 0 4-4V7a4 4 0 0 0-1.4-3.06l-14.33 14.3A4 4 0 0 0 7 21h10Z"
            opacity={0.8}
          />
          <path
            fill="#fff"
            d="M17 6.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 8a4 4 0 1 1-4 4 4.005 4.005 0 0 1 4-4Zm0 2a2 2 0 1 0 2 2 2.003 2.003 0 0 0-2-2Z"
          />
          <path
            fill="#fff"
            d="M7 5.5a1.5 1.5 0 0 0-1.5 1.5v10A1.5 1.5 0 0 0 7 18.5h10a1.5 1.5 0 0 0 1.5-1.5V7A1.5 1.5 0 0 0 17 5.5H7Zm0-1.5h10A3 3 0 0 1 20 7v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3Z"
          />
        </svg>
    </defs>
  </svg>
)
export default SvgComponent
